<template>
  <div class="flex-1 d-flex flex-column justify-center">
    <div class="text-4 text-center">
      Choose Trezor deriviation path:
    </div>
    <br />
    <div class="d-flex mt-5 text-uppercase">
      <div
        class="hd-path-btn h3-18-r flex-1 ml-4 mr-4 clickable pa-5"
        v-for="item in ledgerHdPaths"
        :key="item.path"
        @click="selectHdPath(item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    project: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      backendConfig: "walletUtils/getBackendConfig",
    }),
    ledgerHdPaths() {
      return this.backendConfig.ledgerHDPaths[this.project.config.network].map(
        item => ({
          ...item,
          name: item.name === "Ledger Live" ? "Trezor Live" : item.name,
        })
      );
    },
  },
  methods: {
    selectHdPath(item) {
      this.$emit("selectHdPath", item);
    },
  },
  mounted() {
    if (this.ledgerHdPaths?.length === 1) {
      this.selectHdPath(this.ledgerHdPaths[0]);
    }
  },
};
</script>
<style lang="scss" scoped>
.hd-path-btn {
  width: 180px;
  height: 180px;
  background-color: #fff2ed;
  color: var(--v-primary-base);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 10px;
  &:hover {
    background-color: var(--v-primary-base);
    color: white;
    box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.06);
  }
}</style
>>
